module.exports = __webpack_public_path__ + "static/media/AB_A6_10.ecb74847.jpg";